<template>
    <div>
        <el-dialog
        class="BidDialog"
        :title="uploadFile"
        :visible.sync="bidShow"
        width="840px"
        :close-on-click-modal="false"
        @close="btnEvent('0')"
        height="600px">
            <Upload :text="'上传'" :sizeLimit="100" :accept="uploadFile.indexOf('中标价格表') > -1 ? '.DOC,.DOCX,.PDF' : ''" :uploadDisplayType="'button'" @uploadSuccess="uploadSuccess"></Upload>
            <span class="tip" v-if="uploadFile.indexOf('中标价格表') > -1">(温馨提示：只能上传pdf文件或者word文件)</span>
            <div style="margin-top:10px;width: 100%;">
                <el-table :data="bidFileInfo" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="fileName" label="文件名称" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="200">
                        <template slot-scope="scope">
                            <div style="display:flex">
                                <span class="margin-left"><el-button size="mini" type="text" @click="actionFn(scope.row, '1')">下载</el-button></span>
                                <span class="margin-left"><el-button size="mini" type="text" @click="actionFn(scope.row, '2')">预览</el-button></span>
                                <span class="margin-left"><el-button size="mini" type="text" @click="actionFn(scope.row, '3')">删除</el-button></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="bidSeal">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Upload from '../../../components/upload/Index.vue';
import { filePreview } from '@/utils/filePreview.js';
import { manualUploadFile } from '../../../../lsrm/api/myBidding.js';
export default {
    components: { Upload },
    props: {
        MDialogshow: {
            type: Boolean
        },
        rowBidDialogData: {
            type: Object,
            default() {
                return {};
            }
        },
        uploadFile: {
            type: String
        }
    },
    data() {
        return {
            rowInfo: {},
            bidShow: false,
            bidFileInfo: []
        };
    },
    mounted() {},
    methods: {
        uploadSuccess(res) {
            this.bidFileInfo = [];
            this.bidFileInfo.push({
                fileName: res.data.data.localFileName,
                fileUrl: res.data.data.downUrl,
                fileId: res.data.data.id
            });
        },
        bidModuleFilesFunc() {
            return this.bidFileInfo.map(el => {
                return {
                    fileName: el.fileName,
                    fileUrl: el.fileUrl,
                    fileId: el.fileId,
                    moduleType: el.type === 'BIDDER' ? '4' : '3'
                };
            });
        },
        bidSeal() {
            if (this.bidFileInfo.length === 0) {
                this.$message.warning('请上传中标价格表！');
                return;
            }
            const title = this.uploadFile.indexOf('中标价格表') > -1 ? '请确认是否手工上传中标文件，一旦确定，则供应商应标状态更新为已中标！' : '请确认是否手工上传供应商退款申请函！';
            this.$confirm(title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const par = {
                    bidModuleFiles: this.bidFileInfo[0],
                    bidNo: this.rowInfo.bidNo,
                    supplierCode: this.rowInfo.supplierCode,
                    fileType: this.uploadFile.indexOf('中标价格表') > -1 ? '0' : '1',
                    orderNo: this.rowInfo.orderNo
                };
                manualUploadFile(par).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('上传成功！');
                        this.bidShow = false;
                        this.resetData();
                        this.$emit('mdialogFn');
                    }
                });
            });
        },
        actionFn(row, type, index) {
            if (type === '1') {
                window.open(row.fileUrl, '_parent');
            } else if (type === '2') {
                filePreview(row);
            } else {
                this.bidFileInfo.splice(index, 1);
            }
        },
        btnEvent(type) {
            this.bidShow = false;
            this.resetData();
            this.$emit('mdialogFn');
        },
        resetData() {
            this.bidFileInfo = [];
        }
    },
    watch: {
        MDialogshow(val) {
            this.bidShow = val;
        },
        rowBidDialogData: {
            handler(val, oldval) {
                if (JSON.stringify(val) !== '{}') {
                    this.rowInfo = val;
                }
            },
            deep: true
        }

    }
};
</script>
<style lang="less">
.BidDialog {
    .number {
        color: #00BCBF;
        cursor: pointer;
    }
    .info {
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .el-table__row {
        font-size: 12px;
    }
    .margin-left {
        margin-left: 10px;
    }
    .el-upload {
        color: #00BCBF;
    }
    .tip {
        color: red;
    }
}
</style>